<template>
  <div class="dot-pulse-loader">
    <div class="loadingContainer1">
      <div class="ball1"></div>
      <div class="ball2"></div>
      <div class="ball3"></div>
    </div>
  </div>
</template>

<script>
// import bookTest from '@/components/bookTest.vue'

export default {
  name: 'pulsloader',
    data (){
      return {
      }
    },
  components: {

  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
.dot-pulse-loader {
  height: 20px;
  margin: 5px 0 0 10px;
}
.loadingContainer1 {
    position:relative;
    height: 20px;
    /* display: flex; */
    /* margin: 50px auto 50px auto; */
    width:110px;
}
.loadingContainer1 div {
    height:15px;
    width:15px;
    border-radius:50%;
    /* background: black; */
    float:left;
    margin:0 3px;
    /* background:#6859a3; */
    background:lightgray;
    transform:scale(0);
}
.loadingContainer1 .ball1 {
    z-index:1;
    animation: grow 4.4s infinite ease-in-out;
}
.loadingContainer1 .ball2 {
    animation: grow 4.4s infinite ease-in-out;
    animation-delay: 0.3s;
}
.loadingContainer1 .ball3 {
    animation: grow 4.4s infinite ease-in-out;
    animation-delay: 0.6s;
}
@keyframes grow {
    0% {transform: scale(0);}
    25% {transform: scale(1);}
    50% {transform: scale(0);}
    /* 75% {transform: scale(1);background:#72c2c2;}
    100% {transform: scale(0);background:#72c2c2;} */
    75% {transform: scale(1);}
    100% {transform: scale(0);}
}
</style>
